import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'Why is piano removal more expensive than normal furniture removal?',
      answer: 'Piano removal costs more because pianos are precision musical instruments requiring specialist handling, not just heavy furniture. Professional piano movers invest in purpose‑built equipment including piano boards, heavy‑duty straps rated for 600kg, protective blankets, and stair‑climbing systems that standard removal companies don\'t possess. Their teams receive extensive training in weight distribution, shock absorption, and protecting delicate internal mechanisms. Additionally, specialist piano movers carry comprehensive insurance up to £5 million specifically covering musical instruments, whereas standard removers typically exclude pianos or have inadequate coverage.',
    },
    {
      question: 'Does piano removal cost include insurance in London?',
      answer: 'Reputable piano removal companies in London include comprehensive goods‑in‑transit insurance as standard within their quoted prices. This insurance typically covers up to £5 million for damage to your piano during the move. However, you should always confirm insurance coverage details before booking, as some budget operators may offer lower coverage or charge extra for full protection. Request written confirmation of insurance levels and ensure the policy specifically covers pianos, not just general household goods.',
    },
    {
      question: 'Can I get a same-day piano removal in London?',
      answer: 'Same‑day piano removal in London is occasionally possible for urgent situations, but availability depends on the company\'s schedule and your location. Most specialist piano movers require 2‑3 days notice for weekday moves and 1‑2 weeks for weekend bookings. Same‑day service typically incurs a premium charge of 30‑50% above standard rates. For best availability and pricing, book your piano removal at least one week in advance, particularly during busy periods like end of month or summer holidays.',
    },
  ];

  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-10 text-[#0e0d0b] text-center">
          FAQ — Piano Removal Costs London
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg overflow-hidden hover:border-[#c9a84c] transition-colors"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center bg-[#f5f5f0] hover:bg-[#c9a84c]/5 transition-colors cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-[#0e0d0b] pr-4">
                  {faq.question}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-[#c9a84c] transition-transform flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-6 py-4 bg-white">
                  <p className="text-[#1a1916] leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}